import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getUserApplications } from "../../API/applicationAPI";

/**
 * /feedback route: Redirect to visa application hub (per-form feedback counts)
 * if user has an app in under_review or revision_requested; otherwise dashboard.
 */
const Feedback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirect = async () => {
      try {
        const apps = await getUserApplications();
        const feedbackApp = apps.find(
          (a) =>
            a.stage === "under_review" || a.stage === "revision_requested"
        );
        if (feedbackApp) {
          navigate(
            `/visa-application?applicationId=${feedbackApp.id}&visaType=${feedbackApp.visaType || ""}`,
            { replace: true }
          );
        } else {
          navigate("/dashboard", { replace: true });
        }
      } catch {
        navigate("/dashboard", { replace: true });
      }
    };
    redirect();
  }, [navigate]);

  return (
    <div className="page_main page_main-after-login mt-[100px] pt-[40px] bg-[#F7F8FA] pb-[60px] min-h-[400px] flex items-center justify-center">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#1B365D]" />
    </div>
  );
};

export default Feedback;
